/**
 * PlanPickerCard — list of plans for the chosen event. "+ New plan" is a
 * greyed-out stub pointing at a future FORK (magicmoney-mcp composite write).
 */

import { Plus } from 'lucide-react'
import type { MmOption } from '../api'
import { AgentBubble } from './AgentBubble'

interface PlanPickerCardProps {
  plans: MmOption[]
  busy: boolean
  onPick: (plan: MmOption) => void
}

export function PlanPickerCard({ plans, busy, onPick }: PlanPickerCardProps) {
  return (
    <div className="w-full max-w-xl space-y-4">
      <AgentBubble from="agent">
        Which plan?
      </AgentBubble>

      <div className="rounded-2xl border border-slate-200 bg-white p-2 shadow-sm dark:border-slate-700 dark:bg-slate-800">
        <ul className="max-h-72 divide-y divide-slate-200 overflow-y-auto dark:divide-slate-700">
          {plans.map((plan) => (
            <li key={plan.id}>
              <button
                type="button"
                disabled={busy}
                onClick={() => onPick(plan)}
                className="flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left text-sm text-slate-800 transition hover:bg-carnival-50 disabled:opacity-50 dark:text-slate-100 dark:hover:bg-carnival-400/10"
              >
                <span>{plan.name}</span>
                <span className="text-[10px] text-slate-400">#{plan.id}</span>
              </button>
            </li>
          ))}
          <li>
            <button
              type="button"
              disabled
              className="flex w-full cursor-not-allowed items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-400 dark:text-slate-500"
              title="coming soon — ask Brian to create it in the portal for now"
            >
              <Plus className="h-4 w-4" />
              <span>New plan</span>
              <span className="ml-auto text-[10px] italic">
                coming soon — ask Brian to create it in the portal for now
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}
